import React from "react";

import DashboardHomeSection from "components/DashboardHomeSection";
import DashboardHomeSkeleton from "components/DashboardHomeSkeleton";
import {
    HomeDescription,
    HomeAdditionalText,
    HomeEyebrow,
    HomeHero,
    HomeHeroButton,
    HomeHeroContent,
    HomeHeroImage,
    HomeHeroOverlay,
    HomeScreen,
    HomeSections,
    HomeTitle,
} from "screens/AuthenticatedArea/Dashboard/Home/styled";

export default function DashboardHomeView({ hero, loading, sections, handleAction }) {
    return (
        <HomeScreen>
            {loading ?
                <DashboardHomeSkeleton /> :
                <>
                    <HomeHero>
                        <HomeHeroImage image={hero.imageUrl} />
                        <HomeHeroOverlay />

                        <HomeHeroContent>
                            {hero.eyebrow ? <HomeEyebrow>{hero.eyebrow}</HomeEyebrow> : null}
                            {hero.title ? <HomeTitle>{hero.title}</HomeTitle> : null}
                            {hero.description ? <HomeDescription>{hero.description}</HomeDescription> : null}
                            {hero.additionalText ? <HomeAdditionalText>{hero.additionalText}</HomeAdditionalText> : null}
                            {hero.ctaLabel && hero.ctaUrl ? (
                                <HomeHeroButton onClick={() => handleAction({ type: "navigate", value: hero.ctaUrl })}>
                                    {hero.ctaLabel}
                                </HomeHeroButton>
                            ) : null}
                        </HomeHeroContent>
                    </HomeHero>

                    {!sections.length ? null :
                        <HomeSections>
                            {sections.map((section) => (
                                <DashboardHomeSection key={section.key} section={section} onAction={handleAction} />
                            ))}
                        </HomeSections>}
                </>}
        </HomeScreen>
    );
}
